export const HOME = "/";
export const SIGN_UP = "/signup";
export const LOGIN = "/login";
export const PASSWORD_FORGET = "/pw-forget";
export const ACCOUNT = "/account";
export const HISTORY = "/history";
export const NEW_WALLET = "/wallets/:id";
export const GROUP_WALLET = "/groups/:id";



// WEBPACK FOOTER //
// ./src/constants/routes.js